// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_stylesheet_skeleton__wPDx6","skeletonShimmer":"Skeleton_stylesheet_skeletonShimmer__2EFbl"};